export const SITE_TITLE = 'Stephen Zuniga';
export const SITE_SUBTITLE = 'Software Engineer';

export const MEDIUM_SCREEN = '450px';
export const LARGE_SCREEN = '900px';
